import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

export interface SalesByFair {
  fair_id: number;
  fair_name: string;
  delivery_at: string;
  total_gross: string;
  order_count: number;
}

export function useSalesByFair(params: {
  start_date?: string;
  end_date?: string;
}) {
  const fetch = useFetch();
  const search = new URLSearchParams(
    params as Record<string, string>,
  ).toString();

  return useQuery<SalesByFair[]>({
    queryKey: ["sales-by-fair", params],
    queryFn: () =>
      fetch(`${API}/api/semeadora/reports/sales/by-fair?${search}`),
  });
}
